import { addCookie, editCookie, removeCookie, hasCookie, getCookie } from './scripts/modules/cookieLibrary';

/**
 * Monitor and Store Donation Value Changes
 */
const donationValueChange = () => {

	const donationPriceSelector = "[name=donationAmount]";

	// Handle change
	const handleValueChange = el => {
		const donationAmount = parseFloat(el.value);
		if ( !Number.isInteger(donationAmount) ) {
			setTimeout(() => {
				document.querySelector(`[name=donationCustomAmount]`).focus();
			}, 1000)
			return
		}
		triggerEvent('donationAmountChanged', {donationAmount: donationAmount});
	}

	// Add event listeners on change
	const selectors = Array.from(document.querySelectorAll(donationPriceSelector));
	if (selectors.length == 0) {
		return
	}
	selectors.map(el => el.addEventListener(`click`, event => handleValueChange(event.target)));

	// On load get donation amount
	const initialDonationEl = document.querySelector(`${donationPriceSelector}:checked`);
	if (initialDonationEl === null) {
		return
	}

	handleValueChange(initialDonationEl);

}

/**
 * Monitor and Store Donation Type Changes
 */
const donationTypeChange = () => {
	const selectors = Array.from(document.querySelectorAll("[name=donationType]"));

	const init = (el) => {
		const handleTypeChange = (el) => {
			const donationType = el.target.value;
		}
		el.addEventListener(`click`, handleTypeChange);
	}

	if (selectors.length == 0) {
		return
	}
	selectors.map(el => init(el));

}

/**
 * Monitor and Store Donation Value Changes
 * Applicable when a custom value is added
 */
const customDonationValueChange = () => {

	const selector = document.querySelector("[name=donationCustomAmount]");

	// Handle change
	const handleValueChange = el => {
		let donationAmount = 0;
		if (el.value.length > 0) donationAmount = parseFloat(el.value);
		triggerEvent('donationAmountChanged', {donationAmount: donationAmount});
	}

	if (selector === null) {
		return
	}

	// Add event listeners on change
	selector.addEventListener(`blur`, event => handleValueChange(event.target));

	// On load get donation amount
	// handleValueChange(selector);
}

const COOKIE_NAME = "donated-to-hri";
window.COOKIE_NAME = COOKIE_NAME;

// Make Cookie value available to the window
window.getCookie = getCookie;
window.COOKIE_NAME = COOKIE_NAME;

const changeDonationAmount = ({ donationAmount }) => editCookie(COOKIE_NAME, donationAmount)

const initDonationPage = () => {
	// Setup our listeners
	document.body.addEventListener('donationAmountChanged', data => changeDonationAmount(data.detail));
	donationValueChange()
	customDonationValueChange()
	if (!hasCookie(COOKIE_NAME)) {
		addCookie(COOKIE_NAME);
	}
}

const initConfirmationPage = () => {
	if (hasCookie(COOKIE_NAME)) {
		pushData();
		removeCookie(COOKIE_NAME);
	}
}

const triggerEvent = (eventName, data) => {
	let event;
	if (window.CustomEvent) {
		event = new CustomEvent(eventName, {detail: data});
	} else {
		event = document.createEvent('CustomEvent');
		event.initCustomEvent(eventName, true, true, data);
	}
	document.body.dispatchEvent(event);
}


window.initConfirmationPage = initConfirmationPage
window.initDonationPage = initDonationPage
